module.exports = __webpack_public_path__ + "img/headerimg.05aa42be.png";